import { NgModule, inject, provideAppInitializer } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { FavouritesMatchesComponent } from './components/matchList/favourites-matches.component';
import { run } from './services/favouritesRunService/favourites-run-function';
import { FavouritesRunService } from './services/favouritesRunService/favourites-run.service';

@NgModule({
    imports: [SharedModule],
    exports: [FavouritesMatchesComponent],
    declarations: [FavouritesMatchesComponent],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = run(inject(FavouritesRunService));
            return initializerFn();
        }),
    ],
})
export class FavouritesModule {}
